<template>
    <div class="relative">
        <div
            class="rounded-xl border border-slate-200 bg-white p-3 shadow-xs shadow-slate-200/70 lg:mx-0 lg:ml-auto space-y-2"
        >
            <div class="flex items-center justify-between px-1">
                <div class="flex items-center gap-2">
                    <span class="h-3 w-3 rounded-full bg-red-400"></span>
                    <span class="h-3 w-3 rounded-full bg-amber-400"></span>
                    <span class="h-3 w-3 rounded-full bg-emerald-400"></span>
                </div>
            </div>

            <slot name="addressBar" />

            <div class="overflow-hidden rounded-xl border border-slate-200">
                <Image
                    :src="
                        coverImageUrl ??
                        '/static/images/booking-form/default.webp'
                    "
                    alt="Booking form cover"
                    class="h-28 w-full object-cover"
                />

                <slot name="content" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import Image from '@/Shared/Component/Image.vue'

    defineProps({
        coverImageUrl: {
            type: String,
            default: null,
        },
    })
</script>
